export const ArchivedArticles = [

  {
    "name": "Share A Dream founder Shay Kinsella will be remembered ",
    "content": "Share A Dream Foundation founder Shay Kinsella was remembered at his funeral mass as a “dream maker” who helped thousands of vulnerable children........",
    "link": "https://www.irishmirror.ie/news/irish-news/shay-kinsella-share-a-dream-22437392",
    "date": "29th July 2020",
    "provider": "The Mirror"
  },
  {
    "name": "Preserving Childhood Cancer Care Amid a Pandemic",
    "content": "A survey in 19 countries shows that coordination and messaging at the national level is essential to maintain critical cancer treatment, an expert says.........",
    "link": "https://www.usnews.com/news/best-countries/articles/2020-08-04/study-coronavirus-response-delayed-some-childhood-cancer-treatments",
    "date": "4th Aug 2020",
    "provider": "USNews"
  },
  {
    "name": "Ruth Morrissey: farewell to cervical cancer pioneer",
    "content": "Ruth Morrissey, who campaigned for Cervical Check, was a “beautiful soul” who showed great resilience and strength in her final years, her funeral was told yesterday.......",
    "link": "https://www.thetimes.co.uk/article/ruth-morrissey-farewell-to-incredibly-courageous-cervical-cancer-pioneer-v2l8fmtr6",
    "date": "23rd July 2020",
    "provider": "The Times"
  },
  {
    "name": "€94k is raised for children's cancer charity",
    "content": "Cork parents, whose firstborn son was diagnosed with a rare childhood cancer in 2018, have moved to thank the public for generously supporting a fundraiser.......",
    "link": "https://www.echolive.ie/corknews/Cork-parents-issue-heartfelt-thanks-after-almost-94k-is-raised-for-childrens-cancer-charity-2bb9792a-96d8-41d3-a60a-7f2b726e0748-ds",
    "date": "20th July 2020",
    "provider": "www.echolive.ie"
  },
  {
    "name": "Irish Cancer Society Colour Dash Family 5k",
    "content": "Due to the current coronavirus pandemic, Colour Dash as we know and love it can no longer go ahead. Instead we are inviting you and your family to take part in the first 5k.......",
    "link": "https://www.cancer.ie/ways-to-help/fundraise/colour-dash",
    "date": "5th July 2020",
    "provider": "Irish Cancer Society"
  },
  {
    "name": "Get on your bike for children’s cancer charity",
    "content": "An Irish children’s cancer charity is calling on people to get on their bikes this summer to help ensure that no child in Ireland has to face cancer alone......",
    "link": "https://www.rte.ie/brainstorm/2020/0625/1149549-children-leukaemia/",
    "date": "16th June 2020",
    "provider": "Connaught telegraph"
  },
  {
    "name": "Why do children get leukaemia?",
    "content": "Leukaemia is a type of blood cancer that affects both white blood cells, the key players in the body's defence against infection, and bone marrow, the spongy soft centre of the bone where blood cells are made.....",
    "link": "https://www.rte.ie/brainstorm/2020/0625/1149549-children-leukaemia/",
    "date": "26th June 2020",
    "provider": "RTE"
  },
  {
    "name": "Mayo has highest cancer rate in Ireland over the past decade",
    "content": "Our latest data investigation reveals the western county has held our nation’s highest overall cancer rate over the past decade.Mayo also has the worst rates of five of the most common and deadliest cancers.......",
    "link": "https://www.rte.ie/brainstorm/2020/0625/1149549-children-leukaemia/",
    "date": "17th June 2020",
    "provider": "Irish Mirror"
  },
  {
    "name": "Genetics Could Help ID Childhood Cancer Survivors at Risk for New Malignancies",
    "content": "Analyzing the combination of treatments that childhood cancer survivors received for their malignancies as well as inherited mutations in their DNA-repair genes can help predict their risk for new cancer diagnoses......",
    "link": "https://www.cancerhealth.com/article/genetics-help-childhood-cancer-survivors-risk-new-malignancies",
    "date": "17th June 2020",
    "provider": "cancerhealth.com"
  },
  {
    "name": "Virtual event breaks world record for charity 'strip and dip",
    "content": "An event raising money for childhood cancer has broken an official Guinness World Record for the 'most photos of people in water uploaded to Facebook in one hour', as part of a fundraising 'Strip and Dip' drive.....",
    "link": "https://www.rte.ie/news/ireland/2020/0606/1145885-strip-and-dip/",
    "date": "6th June 2020",
    "provider": "RTE"
  },
  {
    "name": "Significant decline in childhood cancer mortality",
    "content": "A new report from the National Cancer Registry shows that childhood cancer mortality has declined over the past 50 years....",
    "link": "https://www.rte.ie/news/2017/0228/855959-cancer/",
    "date": "28th Feb 2020",
    "provider": "RTE"
  }
]

